import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PushNotificationsActions = createActionGroup({
  source: 'PushNotifications',
  events: {
    'Upload Csv': props<{ id: string; fileName: string; fileData: string }>(),
    'Upload Csv Success': props<{ data: any; fileName: string }>(),
    'Upload Csv Failure': props<{ error: any }>(),

    'Reset State': emptyProps(),
  },
});
